/**
 * Linkola brand mark — the small "Lo" icon (chain + community + heart).
 *
 * Renders the bundled `/linkola-icon.png` sized to fit next to headings
 * and buttons. Accepts a `size` prop (px) for square dimensions.
 *
 * The asset lives in `/frontend/public/linkola-icon.png` so it's served
 * with a stable URL and cached by the browser + Capacitor WebView.
 */
export default function LinkolaMark({ size = 24, className = "", alt = "Linkola", strokeWidth: _strokeWidth, ...rest }) {
  return (
    <img
      src="/linkola-icon.png"
      alt={alt}
      width={size}
      height={size}
      className={`inline-block object-contain ${className}`}
      style={{ width: size, height: size }}
      loading="eager"
      decoding="async"
      {...rest}
    />
  );
}
